<template>
  <div class="agent-findcustomer">
    <sub-title title="找线索"></sub-title>
    <template v-for="item in findList" :key="item.id">
      <AgentDesc
        :avatar-index="item.type === 1 ? 13 : 12"
        :name="item.type === 1 ? '芝麻找客助手' : '芝麻标讯助手'"
      ></AgentDesc>
      <div class="agent-findcustomer-body">
        <div class="find-card">
          <div class="find-card__left">
            <div class="title">{{ item.msg }}</div>
            <div v-if="!isPc" class="desc">
              请前往网页端 AI {{ item.type === 1 ? '芝麻找客助手' : '芝麻标讯助手' }}查看
            </div>
          </div>
          <div class="find-card__right">
            <div class="btn" @click="handleRead(item)">{{ isPc ? '去查看' : '知道了' }}</div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import subTitle from './components/sub-title.vue'
import AgentDesc from './components/agent-desc.vue'

const props = defineProps({
  findList: {
    type: Array,
    default: () => []
  },
  refType: {
    type: Number,
    default: 2
  },
  isPc: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['handleRead', 'goLook'])

const handleRead = (item) => {
  if (props.isPc) {
    emits('goLook', { id: item.id, refType: props.refType, type: item.type })
  } else {
    emits('handleRead', { id: item.id, refType: props.refType })
  }
}
</script>

<style lang="scss" scoped>
.agent-findcustomer {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 8px;
  &-body {
    flex: 1;
    padding-left: 32px;
    display: flex;
    flex-direction: column;
    position: relative;
    .find-card {
      border-radius: 16px;
      display: flex;
      padding: 12px;
      background: #ffffff;
      box-shadow: 0px 2px 30px 2px rgba(0, 0, 0, 0.05);
      margin-bottom: 16px;
      .find-card__left {
        flex: 1;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 16px;
          font-weight: 600;
          line-height: 20px;
          color: #323233;
          margin-bottom: 4px;
        }
        .desc {
          font-size: 13px;
          line-height: 18px;
          color: #969799;
        }
      }
      .find-card__right {
        flex: 0 0 auto;
        margin-left: 12px;
        display: flex;
        align-items: center;
        .btn {
          font-size: 14px;
          font-weight: normal;
          line-height: 20px;
          color: #7a52f4;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
